import React from 'react'
import logo from "../../assets/logo.png";
import './footer.css'

const Footer = () => {
    return (
        <>
            <div className="footer mt-20">
                <hr className='mb-4' />
                <div className="footer-content flex justify-around">
                    <div className="logo flex items-center gap-4 font-semibold">
                        <img src={logo} alt="" />
                        <span>Amazon</span>
                    </div>
                    <div className="footer-detail gap-4 flex flex-col">
                        <span>Contact Us</span>
                        <div className="flex gap-4">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            <span>111 north avenue Orlando, FL 32801</span>
                        </div>
                        <div className="flex gap-4">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                            </svg>
                            <span>352-306-4415</span>

                        </div>
                        <div className="flex gap-4">
                            
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm0 2h10v7h-2l-1 2H8l-1-2H5V5z" clip-rule="evenodd" />
                            </svg>
                            <span>
                                support@amazon.com
                            </span>
                        </div>
                    </div>
                    <div className="footer-detail gap-4 flex flex-col">
                        <span>Account</span>
                        <div className="flex gap-4">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                            </svg>
                            <span>Sign In</span>
                        </div>
                    </div>
                    <div className="footer-detail gap-4 flex flex-col">
                        <span>Company</span>

                        <div className="flex gap-4">

                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                            <span>About Us</span>
                        </div>
                    </div>
                    <div className="footer-detail gap-4 flex flex-col">
                        <span>Resources</span>
                        <div className="flex gap-4">

                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                            </svg>
                            <span>Safety Privacy & Terms</span>
                        </div>


                    </div>
                </div>
                <div className="flex flex-col justify-center items-center mt-8">
                    <span>Copyright ©2022 by Amazon, Inc.</span>
                    <span>All rights reserved.</span>
                </div>
            </div>



        </>
    )
}

export default Footer